import { Capacitor } from '@capacitor/core';

/**
 * Détecte si l'app est en mode native mobile (Capacitor) ou web
 * Capacitor.getPlatform() est synchrone — pas besoin de state/effect
 */
export const useDeviceType = () => {
  const platform = Capacitor.getPlatform();
  const isNativeApp = platform === 'ios' || platform === 'android';
  const isWeb = platform === 'web';

  return {
    isNativeApp,
    isWeb,
    platform,
    isMobileScreen: typeof window !== 'undefined' && window.innerWidth < 768,
  };
};
